var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhArrowRightLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6475 12.3971L13.8975 19.1471C13.7909 19.2465 13.6498 19.3006 13.5041 19.298C13.3584 19.2955 13.2193 19.2364 13.1163 19.1334C13.0132 19.0303 12.9542 18.8913 12.9516 18.7455C12.949 18.5998 13.0031 18.4588 13.1025 18.3521L18.8916 12.5621H3.75C3.60082 12.5621 3.45774 12.5029 3.35225 12.3974C3.24676 12.2919 3.1875 12.1488 3.1875 11.9996C3.1875 11.8505 3.24676 11.7074 3.35225 11.6019C3.45774 11.4964 3.60082 11.4371 3.75 11.4371H18.8916L13.1025 5.64714C13.0031 5.54051 12.949 5.39947 12.9516 5.25375C12.9542 5.10802 13.0132 4.96898 13.1163 4.86592C13.2193 4.76286 13.3584 4.70383 13.5041 4.70126C13.6498 4.69869 13.7909 4.75278 13.8975 4.85214L20.6475 11.6021C20.7528 11.7076 20.812 11.8506 20.812 11.9996C20.812 12.1487 20.7528 12.2917 20.6475 12.3971Z",
    fill: "#BD3193"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhArrowRightLight);
export default __webpack_public_path__ + "static/media/ph_arrow_right_light.ba43f9a5abb016bc518fd9e017f5881f.svg";
export { ForwardRef as ReactComponent };